import { FloatingHelper } from '@wix/design-system';
import React from 'react';
import { composer } from '../../../../../component-decorators/composer';
import { isWixApp, wixChatBotLink } from '../../../../../common/utils';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import type { WebSolution } from '@wix/ambassador-marketplace/types';

interface IBlockReviewsHelperProps extends Partial<WithTranslationProps> {
  app: WebSolution;
  opened: boolean;
  target: string;
}

export const BlockReviewsHelper = composer()
  .withTranslation()
  .compose(({ t, app, opened, target }: IBlockReviewsHelperProps) => {
    const getActionText = () => {
      return isWixApp(app?.company?.companyBase?.id)
        ? t('solution.page.reviews.block-helper-cta2')
        : t('solution.page.reviews.block-helper-cta1');
    };

    const getContent = () => {
      return isWixApp(app?.company?.companyBase?.id)
        ? t('solution.page.reviews.block-helper-description-wix', {
            appName: app?.baseInfo.name,
          })
        : t('solution.page.reviews.block-helper-description', {
            appName: app?.baseInfo.name,
          });
    };

    const onActionClick = () => {
      if (isWixApp(app?.company?.companyBase?.id) && window) {
        window.open(wixChatBotLink);
      } else if (window) {
        const supportMails = app?.supportEmails.join(';');
        window.location.href = 'mailto:' + supportMails;
      }
    };

    return (
      <FloatingHelper
        target={t(target)}
        content={
          <FloatingHelper.Content
            title={t('solution.page.reviews.block-helper-title')}
            body={getContent()}
            actionText={getActionText()}
            onActionClick={() => onActionClick()}
            actionTheme="standard"
          />
        }
        zIndex={1456}
        opened={opened}
        placement="top-end"
        appearance="light"
      />
    );
  });
